import script from "./AddressDetailsFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressDetailsFields.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__